import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function PowerPerformanceData({ id, plantName }) {
  const [performanceData, setPerformanceData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch performance list by power_id
  useEffect(() => {
    if (id) {
      axios
        .get(`https://backend-zkgn.onrender.com/api/powergen_performance/${id}`)
        .then((response) => {
          setPerformanceData(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching performance data:", error);
          setLoading(false);
        });
    }
  }, [id]);

  const handleDelete = async (gen_perform_id) => {
    if (window.confirm("Are you sure you want to delete this entry?")) {
      try {
        await axios.delete(
          `https://backend-zkgn.onrender.com/api/powergen_performance/${gen_perform_id}`
        );

        setPerformanceData((prev) =>
          prev.filter((item) => item.gen_perform_id !== gen_perform_id)
        );
      } catch (error) {
        alert("Failed to delete. Please try again.");
        console.error("Error deleting entry:", error);
      }
    }
  };

  return (
    <div className="container-fluid my-5">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h4 className="fw-bold text-tertiary mb-2">Power Generation Performance</h4>

        <Link to={`/add-powerperformance/${plantName}/${id}`} className="btn btn-primary">
          Add Power Performance Data
        </Link>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-sm performance-table">
            <thead className="table-light">
              <tr>
                <th>Fiscal Year</th>
                <th>Total Installed Capacity (MW)</th>
                <th>Hydro (MW)</th>
                <th>Coal (MW)</th>
                <th>Gas (MW)</th>
                <th>Solar (MW)</th>
                <th>Renewable (MW)</th>
                <th>Hydro (MU)</th>
                <th>Coal (MU)</th>
                <th>Gas (MU)</th>
                <th>Total Generated (MU)</th>
                <th>Non-Conventional (MU)</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {performanceData.map((data) => (
                <tr key={data.gen_perform_id}>
                  <td>{data.fiscal_year}</td>
                  <td>{data.tot_inst_capacity}</td>
                  <td>{data.hydro_mw}</td>
                  <td>{data.coal_mw}</td>
                  <td>{data.gas_mw}</td>
                  <td>{data.solar_mw}</td>
                  <td>{data.renewable_mw}</td>
                  <td>{data.hydro_mu}</td>
                  <td>{data.coal_mu}</td>
                  <td>{data.gas_mu}</td>
                  <td>{data.tot_gen_mu}</td>
                  <td>{data.non_conventional}</td>

                  <td className="text-end">
                    <Link
                      to={`/edit-powerperformance/${data.gen_perform_id}`}
                      className="btn btn-link text-success me-3 p-0"
                    >
                      <i className="fa fa-edit"></i>
                    </Link>

                    <button
                      className="btn btn-link text-danger p-0"
                      onClick={() => handleDelete(data.gen_perform_id)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default PowerPerformanceData;
